import React from 'react';
import MasterCard from '../../images/cards/mc.png';
import Diners from '../../images/cards/diners.png';
import Visa from '../../images/cards/visa-2.png';
import VisaIcon from '../../images/cards/visa-cc-icon.png';
import MasterCardIcon from '../../images/cards/mastercard-cc-icon.png';
import DinersIcon from '../../images/cards/diners-cc-icon.png';
import UnknownIcon from '../../images/cards/unknown-icon.svg';
import AmericanExpressIcon from '../../images/cards/american-express-cc-icon.png';
import { withTranslation } from 'react-i18next';
import Parent from '../../common/parent';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import CacheData from '../../common/utils/cacheData';
import { constants } from '../../common/constants/constants';
import CreditCardLogic from './creditCardLogic';
import $ from "jquery";
import {GAEvent} from "../../common/google_analytics/google_analytics";
import './CreditCard.scss';
import {triggerRewardsNotification} from '../../managers/rewards/rewardsEvent';
import {Currency} from "../../common/currency";

const unknown = {'image':  UnknownIcon}
const CARDS = {
    // we don't support payments from american express currently.
    'ae': {'image':  AmericanExpressIcon},
    'mc': {'image':  MasterCardIcon},
    // diners is a part of american express AFAIK
    'diners': {'image':  DinersIcon},
    'visa': {'image':  VisaIcon},
    'unknown': unknown
}

/// example from tranzila
/// https://vucra.com/online05/oneline05.html

export class CreditCardForm extends Parent {

    constructor(props) {
        super(props);
        document.title = props.parentProps.t('titles.make_payment');

        BllinkLogger.info(`CreditCard constructor `, props);
        this.displayAmericanExpressError.bind(this);
        this.cardTypeChanged.bind(this);
        this.showErrorPopUp.bind(this);
        // cartID will be used to identify the transaction against tranzila (or any other gateway)
        const createCartResponse = CacheData.fetchCache(`createCartResponse`, {cartID: props.cartID});
        BllinkLogger.info(`CreditCard createCartResponse for cart ${props.cartID}`, createCartResponse);
        const isFuturePayment = createCartResponse?.charge_date ? (new Date(createCartResponse?.charge_date) > new Date()) : false;
        this.state = {
            cartID: props.cartID,
            nextMonthsPaymentsData: {},
            createCartResponse: createCartResponse,
            yearsRange: this.nextTenYears(),
            isFuturePayment,
            chargeDate: createCartResponse?.charge_date
        }

        this.timeUtils.getCurrentYear()
    }

    onScriptLoad = async () => {
        BllinkLogger.info(`CreditCard onScriptLoad`, this.props);
        let options = {
            isFailedPaymentForm: this.props.isFailedPaymentForm,
            paymentTerminal: this.props.paymentTerminal,
            // will not charge the user but performe a validation J5 txn
            ...(this.state.isFuturePayment && {tran_mode: 'V'})
        };
        BllinkLogger.info(`CreditCard onScriptLoad options`, options);
        CreditCardLogic.initTranzila(this.pollOrderStatus, this, options);
    }

    async pollOrderStatus(cartId, thisObj, counter){
        /*
           thisObj is lost unless sent here back from CreditCardLogic
        */

        if (thisObj.props.isFailedPaymentForm){
            // the cartID for failed will look like this f-<rawRealToken> so need to strip the `f-` prefix
            cartId = cartId.replace(constants.APIContract.failedPayments.cartIDPrefix, '');
        }

        const order = await thisObj.fetchOrderStatus(cartId);
        const timer = 2000;
        if (thisObj.isOrderSuccess(order)){
            GAEvent(constants.GoogleAnalytics.Events.creditCard, `redirectToStatusAfterSuccess_try_${counter}`);
            // todo show in bootstrap dialog box of a successful payment? i18n.t('payments.payment_confirmation')
            // TODO: this code looks weird - no startLoader call, consider to remove
            thisObj.endLoader();
            triggerRewardsNotification();
            // returned to page reload due to complains of some managers
            // that they can't charge twice (reported by mor)
            // thisObj.props.parentProps.history.push(`/status/${cartId}`);
            window.location.href = `/status/${cartId}`;
        }else {
            counter += 1
            // todo if more than 10 seconds has passed, show an error message
            setTimeout(() => {
                thisObj.pollOrderStatus(cartId, thisObj, counter)
                },
            timer);

            if (counter * timer > 10000){
                GAEvent(constants.GoogleAnalytics.Events.creditCard, 'didntRedirectStill', 1, counter * timer);
            }
        }
    }

    isOrderSuccess(order){
        BllinkLogger.info(`inspecting `, order);
        return  (
            constants.PaymentPlanDetailsStatus.ALL_SUCCESS.includes(order.payment_details.state)
        )
    }

    nextTenYears(){
        // used in the selector
        let currentYear = this.timeUtils.getCurrentYear()
        return this.JsExtras.range(currentYear, 20)
    }

    async componentDidMount() {
        if (!window.TzlaHostedFields) {
            this.loadScript(
                `https://hf.tranzila.com/assets/js/thostedf.js`,
                this.onScriptLoad
            );
        } else {
            await this.onScriptLoad();
        }
    }

    cardTypeChanged(newType){
        /*
            https://www.marketwatch.com/story/how-to-decode-your-credit-card-numbers-2017-08-25

            First digit: 2; Credit card issuer: Mastercard (2017)
            First digit: 3; Credit card issuer: American Express AXP, -2.01%
            First digit: 4; Credit card issuer: Visa
            First digit: 5; Credit card issuer: Mastercard
            First digit: 6; Credit card issuer: Discover DFS, -0.94%

            options are mc (mastercard), visa, ae, unknown

         */

        const imageName = (CARDS[newType] || unknown).image;
        $("#credit-card-icon").attr('src', imageName)
            .removeClass().addClass(newType)
            .parent('.card-type').attr('hidden', false);

        let blockedProviders = this.props.blockedProviders || [];
        BllinkLogger.info(`blockedProviders are `, blockedProviders);
        if (blockedProviders.includes(newType)){
           this.displayAmericanExpressError() // todo display by actual name of the provider
        }else{
            this.hideErrors()
        }

    }

    displayAmericanExpressError(){
        /*
            we don't accept american express currently, so we want to notify
            the user before she click on the pay button
         */

        const {t} = this.props.parentProps;

        $('#cc-error').text(t('payments.dont_accept_america_express_cards')).parent('.row').attr('hidden', false).show() // not sure what works exactly.
    }

    hideErrors(){
        $('#cc-error').parent('.row').hide()
    }

    showErrorPopUp(errorText){

       const {t} = this.props.parentProps;
       if (errorText === 'Incorrect identity number or CVV.'){
          errorText = t('payments.incorrect_cvv');
       }

       $('#errorModal .modal-body p').text(errorText);
       // append to body - https://stackoverflow.com/a/15780841/13806459
       // https://app.asana.com/0/1196545425570329/1198890480504266
       $('#errorModal').appendTo('body').modal('show');
    }

    renderChargeErrorPopUp(){
        const {t} = this.props.parentProps;

        return (

            <div className="modal fade" id="errorModal">
                <div className="modal-dialog new_modal_content">
                    <div className="modal-content n_content">
                        <div className="modal-header">
                            <h5 className="col-12 modal-title text-center" id="errorModalLabel">{t('payments.payment_error')}</h5>
                        </div>
                        <div className="modal-body">
                            <p className="text-center"/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderPayButton(){
        const {t} = this.props.parentProps;
        if (this.props.renderPayButton) {
            return <button tabIndex={5} id="card_submit" type="submit" className="btn form-control CardField-button">
                <span dir="rtl">{t('payments.charge_card')}</span>
            </button>
        }
    }

    renderTouristComment(){
        const {t} = this.props.parentProps;
        if (this.props.hasCommission) {
            return <span>*{t('payments.tourist_comment')}</span>
        }
    }

    renderHiddenAmount(){
        let rewardAmount = (this.state.createCartResponse && this.state.createCartResponse.firstRewardTotal) || 0;
        if (this.props.amountForFirstPayment) {
            return <input type="hidden" id="total-amount-for-card" value={this.props.amountForFirstPayment - rewardAmount}/>
        }
    }

    renderTotalPayAmount(){
        const s = this.BllinkUtils.Strings;
        BllinkLogger.info('will reward amount ', this.state.createCartResponse);
        let rewardAmount = (this.state.createCartResponse && this.state.createCartResponse.firstRewardTotal)
        // amountForFirstPayment should always be the full amount without the reward
        // was changed due to a bug where the user sometimes saw the reward and sometimes didn't
        // https://app.asana.com/0/1200654622299830/1200772846255162
        if (rewardAmount){
            return (
                <span>
                    <del className={'text-space'}>{s.numberWithCommas(this.props.amountForFirstPayment)}</del>
                    {s.numberWithCommas(this.props.amountForFirstPayment - rewardAmount)}
                </span>
            )
        }

        return s.numberWithCommas(this.props.amountForFirstPayment)
    }

    renderTotalToPayTitle(){
        const {t} = this.props.parentProps;


        if (this.props.currency) {
            let isOnePaymentCart = this.props.isOnePaymentCart;
            let totalToPayJustText = isOnePaymentCart ? t('payments.first_charge_one_payment_only') : t('payments.first_charge');
            BllinkLogger.info('will render amount ', this.props.amountForFirstPayment);

            return <h4>
                {totalToPayJustText} {this.renderTotalPayAmount()} <Currency>{this.props.currency}</Currency>
                {this.state.isFuturePayment && (
                    <p>{t('card_page.future_charge', {date: this.timeUtils.parseDate(this.state.chargeDate)})}</p>
                )}
            </h4>
        }

    }

    renderCreditCardForm(){
        /*
            card number
            expiry
            cvv

            pay button
            tourist comment disclaimer
         */

        const {t} = this.props.parentProps;

        return (
            <form className="card_from_new" _lpchecked="1" id="payment_form">
                <div className="inner_from_Div">
                    <div className="row form-group card-visa">
                        <label className='label'>{t('card_page.card_number')} </label>
                        <span tabIndex={1} className="form-control" id="credit-card" inputMode="numeric" />
                        <span className="card-type" hidden={true}>
                                        <img id="credit-card-icon" alt="cc-icon"/>
                                    </span>

                    </div>
                    <div className="row form-group col-12 col-md-11" hidden={true}>
                        <label id="cc-error" className="error"/>
                    </div>
                    <div className="row">
                        <div className="form-group year col-lg-3 col-5">
                            <label className='label'>{t('payments.year')} </label>
                            <select tabIndex={2} name="apartment-number" className="js-year" id="month-or-year-select">
                                {this.state.yearsRange.map((value, index) => {
                                    return <option key={value} value={value} >{value}</option>
                                })}
                            </select>

                        </div>
                        <div className="form-group month col-lg-3 col-6">
                            <label className='label'>{t('payments.month')} </label>
                            <select tabIndex={3} name="apartment-number" className="js-month month-card" id="month-or-year-select">
                                {constants.months.map((value, index) => {
                                    return <option key={value} value={value} >{value + ' - ' + t(`common.months.${value}`)}</option>
                                })}
                            </select>

                        </div>
                        <div className="form-group cvv col-lg-6 col-12">
                            <label className='label'>{t('card_page.cvv')} </label>
                            <span tabIndex={4} className="form-control" id="Cvv"/>
                        </div>

                    </div>

                    <div className="Card-Errors"/>
                    <div className="form-group N_grp text-center">
                        {this.renderPayButton()}
                    </div>
                    <div className="col-12 tourist-line label">
                        {this.renderTouristComment()}
                    </div>
                </div>
            </form>
        )
    }

    renderPaymentsTokenIfRelevant(){
        if (this.props.paymentsToken){
            return <input type="hidden" id="paymentsToken-input" value={this.props.paymentsToken} />
        }
    }

    render() {

        const {t} = this.props.parentProps;

        return (
            <div className="container">
                {this.renderHiddenAmount()}
                <input type="hidden" id="cartID-input" value={this.state.cartID} />
                {this.renderPaymentsTokenIfRelevant()}
                <div className="container">
                    <div className="chk_card">
                        {this.renderTotalToPayTitle()}
                        {this.renderCreditCardForm()}
                    </div>
                </div>
                <section>
                    <div className="container">
                        <div className="img_thumbnails_set">
                            <h5>{t('payments.payment_services')}</h5>
                            <div className="card_img_set_99">
                                <p><img className='photo-available-card' alt={'visa'} src={Visa}/></p>
                                <p><img className='photo-available-card' alt={'master_card'} src={MasterCard}/></p>
                                <p><img className='photo-available-card' alt={'diners'} src={Diners}/></p>
                                <p><img className='photo-available-card' alt={'ae'} src={AmericanExpressIcon}/></p>
                            </div>
                            <p>{t('payments.payment_services_via_tranzila')} </p>
                        </div>
                    </div>
                </section>
                {this.renderChargeErrorPopUp()}
            </div>
        )
    }
}

export default withTranslation()(CreditCardForm);
